<template>
  <div>
    <input
      :class="['w-full', error ? 'error' : '']"
      @keyup="keyup($event)"
      :value="value"
      :placeholder="placeholder"
      :disabled="disable"
      @input="trigger($event)"
      @focus="focus"
      :type="type"
      :readonly="readonly"
    />
    <span class="text-red-500" v-if="error">
      {{ errorMessage }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    value: {},
    disable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "Placeholder"
    },
    readonly: {
      type: String
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      // type: Boolean
    },
    errorMessage: {
      type: String
    }
  },
  methods: {
    keyup(e) {
      this.$emit("keyup");
    },
    trigger(e) {
      this.$emit("input", e.target.value);
    },
    focus() {}
  }
};
</script>
<style scoped lang="scss">
input {
  height: 34px;
  border-radius: 10px;
  border-width: 1px;
  font-size: 14px;
  border: 1px solid #DFE0EB;
  color: #000;
  padding: 1rem;
}
.error {
  border: 1px solid red;
}

input:focus {
  // outline: 1px color(bv-primary) solid;
  outline: none;
}
</style>
